import { Employee, SchedulePlaceholder } from '../types';

export const PLACEHOLDER_ROW_OFFSET = 1_000_000_000;
const VISIBLE_STORAGE_KEY = 'scheduling_visiblePlaceholders';

export function loadVisiblePlaceholderIds(scheduleId: number): number[] {
  if (!scheduleId) return [];
  try {
    const raw = localStorage.getItem(`${VISIBLE_STORAGE_KEY}_${scheduleId}`);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(Number).filter((id) => id > 0) : [];
  } catch {
    return [];
  }
}

export function saveVisiblePlaceholderIds(scheduleId: number, ids: number[]): void {
  if (!scheduleId) return;
  localStorage.setItem(
    `${VISIBLE_STORAGE_KEY}_${scheduleId}`,
    JSON.stringify(ids.filter((id, index) => ids.indexOf(id) === index))
  );
}

export function employeesWithVisiblePlaceholders(
  placeholders: SchedulePlaceholder[],
  people: Employee[],
  visibleIds: number[]
): Employee[] {
  const visible = new Set(visibleIds);
  return [
    ...placeholders.filter((p) => visible.has(p.id)).map(toPlaceholderEmployee),
    ...people.filter((e) => !e.isPlaceholder),
  ];
}

export function isPlaceholderRowId(id: number): boolean {
  return Number(id) >= PLACEHOLDER_ROW_OFFSET;
}

export function placeholderIdFromRowId(id: number): number {
  return Number(id) - PLACEHOLDER_ROW_OFFSET;
}

export function rowIdForPlaceholder(placeholderId: number): number {
  return PLACEHOLDER_ROW_OFFSET + Number(placeholderId);
}

export function toPlaceholderEmployee(placeholder: SchedulePlaceholder): Employee {
  return {
    id: rowIdForPlaceholder(placeholder.id),
    firstName: placeholder.name,
    lastName: '',
    email: 'Placeholder seat',
    isActive: true,
    isPlaceholder: true,
    placeholderId: placeholder.id,
    createdAt: placeholder.createdAt || new Date().toISOString(),
  };
}

export function assigneeFromGridRow(rowId: number): { employeeId?: number; placeholderId?: number } {
  if (isPlaceholderRowId(rowId)) {
    return { placeholderId: placeholderIdFromRowId(rowId) };
  }
  return { employeeId: Number(rowId) };
}

export function gridEmployeeIdFromShift(shift: {
  employeeId?: number | null;
  placeholderId?: number | null;
}): number {
  if (shift.placeholderId) return rowIdForPlaceholder(Number(shift.placeholderId));
  return Number(shift.employeeId);
}

export function assigneeRowId(payload: { employeeId?: number | null; placeholderId?: number | null }): number {
  if (payload.placeholderId) return rowIdForPlaceholder(Number(payload.placeholderId));
  return Number(payload.employeeId);
}
